<template>
  <v-card
    v-if="name && url"
    @click="$emit('select')"
    class="d-flex flex-column overflow-hidden card-file"
    height="100%"
  >
    <div class="position-relative">
      <template v-if="fileExtension === 'pdf'">
        <PdfPreviewWidget :id="file" :url="url" />
      </template>

      <template v-if="['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension)">
        <img class="d-block responsive" :src="url" />
      </template>

      <template v-if="fileExtension === 'mp4'">
        <video
          class="d-block responsive"
          preload="metadata"
          crossorigin="anonymous"
          webkit-playsinline
          playsinline
          controls
        >
          <source :src="url" type="video/mp4" />
          Seu navegador não suporta vídeo HTML5.
        </video>
      </template>

      <template
        v-if="
          ['doc', 'docx', 'xls', 'xslx', 'ppt', 'pptx'].includes(fileExtension)
        "
      >
        <div class="d-flex align-center justify-center responsive">
          <v-icon size="56"> mdi-file-document-outline </v-icon>
        </div>
      </template>

      <v-sheet
        class="d-flex align-center justify-center card-file-checkbox"
        height="26px"
        width="26px"
      >
        <v-icon
          class="card-file-checkbox-icon d-block"
          color="secondary"
          size="20"
        >
          {{ checkbox }}
        </v-icon>
      </v-sheet>

      <div class="card-file-menu">
        <v-menu
          content-class="rounded-lg mt-2 menu-dropdown"
          min-width="120px"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="white" small icon>
              <v-icon color="secondary">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list class="pa-1">
            <!-- alterar href para gallery quando for imagem -->
            <v-list-item
              class="rounded-lg overflow-hidden px-3"
              :href="url"
              target="_blank"
              dense
            >
              <v-list-item-title> Visualizar </v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              @click="editar(doc)"
              class="rounded-lg overflow-hidden px-3"
              dense
            >
              <v-list-item-title> Editar </v-list-item-title>
            </v-list-item> -->

            <div class="mx-n1">
              <v-divider class="my-1" />
            </div>

            <v-list-item
              @click="$emit('delete')"
              class="error--text rounded-lg overflow-hidden px-3"
              dense
            >
              <v-list-item-title> Excluir </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-divider />

    <v-sheet
      class="d-flex flex-column justify-center pa-2"
      color="transparent"
      height="100%"
    >
      <div
        class="black--text text-caption text-sm-body-2 text-center font-weight-medium card-file-name"
      >
        {{ name }}
      </div>

      <div
        class="secondary--text text--lighten-2 text-caption text-center font-weight-regular mt-1"
      >
        {{ formatDate(created_at) }}
      </div>
    </v-sheet>
  </v-card>
</template>

<script>
import PdfPreviewWidget from "@/components/widgets/PdfPreview.vue";
import formatDate from "@/utils/formatDate";

export default {
  components: { PdfPreviewWidget },
  props: {
    id: Number,
    name: String,
    url: String,
    file: String,
    created_at: String,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkbox() {
      return this.checked
        ? "mdi-checkbox-marked"
        : "mdi-checkbox-blank-outline";
    },
    fileExtension() {
      return this.file.split(".").pop().toLowerCase();
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.card-file {
  background-color: #ffffff;
  border: 1px solid #ddd6d2 !important;
  border-radius: 16px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0 0 0 / 0.1) !important;
  transition: all 0.1s linear;

  @media screen and (max-width: 599.9px) {
    border-radius: 8px !important;
    padding: 12px;
  }

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;
  }

  &-checkbox {
    border-radius: 4px;
    left: 5px;
    position: absolute;
    top: 5px;

    &-icon {
      margin-top: -2px;
    }
  }

  &-menu {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  &-name {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.responsive {
  aspect-ratio: 16 / 9;
  height: auto !important;
  object-fit: cover;
  object-position: top;
  width: 100%;
}
</style>
